export default "__VITE_ASSET__eRa$boh$__"